import { render, staticRenderFns } from "./ArhivedInQualityHeaderIcons.vue?vue&type=template&id=59c05275&"
import script from "./ArhivedInQualityHeaderIcons.vue?vue&type=script&lang=js&"
export * from "./ArhivedInQualityHeaderIcons.vue?vue&type=script&lang=js&"
import style0 from "./ArhivedInQualityHeaderIcons.vue?vue&type=style&index=0&id=59c05275&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports